import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "subtable_template text-start bg-light fw-normal" }
const _hoisted_2 = ["colspan"]
const _hoisted_3 = { class: "d-flex px-3" }
const _hoisted_4 = { class: "flex-1 d-flex flex-column gap-4" }
const _hoisted_5 = { class: "d-flex flex-column" }
const _hoisted_6 = { class: "text-gray-400" }
const _hoisted_7 = { class: "fw-bold" }
const _hoisted_8 = { class: "flex-1 d-flex flex-column gap-4" }
const _hoisted_9 = { class: "d-flex flex-column" }
const _hoisted_10 = { class: "text-gray-400" }
const _hoisted_11 = { class: "fw-bold" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1 d-flex flex-column gap-4" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1 d-flex flex-column gap-4" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("tr", _hoisted_1, [
    _createElementVNode("td", {
      colspan: _ctx.tableColspans,
      class: "text-start px-20 py-9"
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("finacialReport.carryForwardOrderNo")) + ":", 1),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.itemData.carry_down_order_no ? _ctx.itemData.carry_down_order_no : "--"), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("finacialReport.carryForwardBalance")) + ":", 1),
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.itemData.carry_down_balance ? _ctx.itemData.carry_down_balance : "--"), 1)
          ])
        ]),
        _hoisted_12,
        _hoisted_13
      ])
    ], 8, _hoisted_2)
  ]))
}